import { render, staticRenderFns } from "./myImport.vue?vue&type=template&id=0af9ab31&"
import script from "./myImport.vue?vue&type=script&lang=js&"
export * from "./myImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports